// client/src/coms/conversations/ChatsView.js
// Chats: every recent conversation in one place (pinned, unread, recent channels and DMs from any server),
// opened with one tap. Search reaches every channel and DM, not only recent ones.
import React, { useMemo, useState } from 'react';
import ConversationSections from './ConversationList';
import './conversations.css';

export default function ChatsView({ index, onOpen, onPin, pinnedIds, activeId }) {
  const [query, setQuery] = useState('');
  const results = useMemo(() => (query.trim() ? index.search(query) : null), [index, query]);
  const nothing = !index.pinned.length && !index.unread.length && !index.recent.length;

  return (
    <div className="coms-view vx-chats" data-testid="chats-view">
      <div className="vx-chats-head">
        <input
          type="search"
          className="vx-chats-search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search people, servers and channels"
          aria-label="Search conversations"
          enterKeyHint="go"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && results && results[0]) onOpen(results[0]);
          }}
          data-testid="chats-search"
        />
      </div>
      <div className="vx-chats-body">
        {results ? (
          <ConversationSections sections={[{ key: 'results', title: results.length ? 'Results' : 'No results', items: results, empty: `Nothing matches “${query.trim()}”. Try part of a name, server or channel.` }]} onOpen={onOpen} onPin={onPin} pinnedIds={pinnedIds} activeId={activeId} />
        ) : nothing ? (
          <div className="vx-conv-empty-state">
            <div aria-hidden="true">🗨️</div>
            <strong>{index.loaded ? 'No conversations yet' : 'Loading conversations…'}</strong>
            {index.loaded ? <p>Channels and DMs you open appear here, with unread ones first. Use Servers to find a channel, or DMs to message a friend.</p> : null}
          </div>
        ) : (
          <ConversationSections
            sections={[
              { key: 'pinned', title: 'Pinned', items: index.pinned },
              { key: 'unread', title: 'Unread', items: index.unread },
              { key: 'recent', title: 'Recent', items: index.recent },
            ]}
            onOpen={onOpen}
            onPin={onPin}
            pinnedIds={pinnedIds}
            activeId={activeId}
          />
        )}
      </div>
    </div>
  );
}
